import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { FlexColumn } from 'ui-components/components/flex/column';
import { Gap } from 'ui-components/components/flex/gap';

import UserTimeFormat from '../../../../../../../components/user-time-format/connected';
import UserDateFormat from '../../../../../../../components/user-date-format/index';

import { messages } from './messages';

type ToteInfoTooltipProps = {
  children: ReactNode;
  pickerName: string | null;
  processedUtc: string | null;
};

export const ToteInfoTooltip = ({ children, pickerName, processedUtc }: ToteInfoTooltipProps) => {
  const hasPickerInfo = pickerName || processedUtc;

  if (!hasPickerInfo) {
    return children;
  }

  return (
    <Tooltip position='bottom'>
      {children}
      <TooltipContent>
        <FlexColumn gap={Gap.Space4}>
          {pickerName && <FormattedMessage {...messages.pickedBy} values={{ pickerName }} />}
          {processedUtc && (
            <span>
              <UserDateFormat value={processedUtc} />
              &nbsp;
              <UserTimeFormat value={processedUtc} />
            </span>
          )}
        </FlexColumn>
      </TooltipContent>
    </Tooltip>
  );
};
